const formFieldCopyIDs = {

  // Traveler Form
  corporateFrequentFlyerNumber: 'PAX_CORPORATE_NUMBER',
  corporateFrequentFlyerNumberAM: 'FFP_AEROMEXICOC',
  corporateFrequentFlyerNumberDelta: 'PAX_CORPORATE_NUMBER_DELTA',
  countryCode:'PAX_COUNTRY_OF_RESIDENCE',
  dateOfBirth: 'PAX_DOB',
  email: 'APP_EMAIL',
  enrollmentDescription:'PRO_HOME2.0_ENROLLMENT_DESCRIPTION',
  enrollmentTitle: 'PRO_HOME2.0_ENROLLMENT_TITLE',
  firstName: 'PAX_FIRST_NAME',
  firstNames: 'PAX_FIRST_NAMES',
  frequentFlyerNumber: 'PAX_FFP_NUMBER',
  frequentFlyerProgram: 'PAX_FFP',
  corporateFreqFlyerProgram: 'PAX_CORP_FFP',
  gender: 'PAX_GENDER',
  isCountryEU:'PRO_HOME2.0_EUROPE_USER',
  ktn: 'APP_KTN',
  lastName: 'PAX_LAST_NAME',
  lastNames: 'PAX_LAST_NAMES',
  lastNameRegister: 'PRO_HOME2.0_LAST_NAME',
  mealPreference: 'PAX_MEAL_PREFERENCE',
  middleName: 'PAX_MIDDLE_NAME',
  middleNames: 'PAX_MIDDLE_NAMES',
  nickname: 'PAX_NICKNAME',
  parentBannerText:'PRO_HOME2.0_TUTOR_DESCRIPTION',
  parentBannerTitle: 'PRO_HOME2.0_TUTOR_TITLE',
  parentLabel: 'USER_PROFILE_FFNUMBER_TUTOR',
  passwordLabel: 'APP_PASSWORD',
  passwordTooltip: 'PRO_HOME2.0_PSW_DESCRIPTION',
  phoneNumbers: 'PAX_PHONE_NUMBER',
  phoneType: 'PAX_PHONE_TYPE',
  phoneTypeCP: 'PRO_HOME2.0_PHONE_TYPE_CP',
  redress: 'APP_REDRESS',
  specialServicesRequired: 'APP_SPECIAL_SERVICES',
  telephonePIN:'PRO_HOME2.0_NIP',
  telephonePINTooltip: 'PRO_HOME2.0_NIP_DESCRIPTION',
  upToDate: 'PAX_STAY_UP_TO_DATE',
  newsletterRegistration: 'APP_NEWSLETTER',
  saveCardtoProfile: 'SAVE_CARD_IN_MY_PROFILE',
  emails: 'APP_EMAIL_OPTIONAL',

  // Check-in Traveler Form
  destinationAddress: 'REVIEW_STREET_ADDRESS',
  destinationApt: 'REVIEW_APT_UNIT',
  destinationCity: 'REVIEW_CITY',
  destinationCountry: 'REVIEW_COUNTRY',
  destinationState: 'REVIEW_STATE_PROVINCE',
  destinationZipCode: 'REVIEW_ZIP_POSTAL',
  emergencyContactCountry: 'PAX_COUNTRY',
  emergencyContactFirstName: 'PAX_EMERGENCY_FIRST_NAME',
  emergencyContactLastName: 'PAX_LAST_NAME',
  emergencyContactPhoneNumber: 'PAX_PHONE_NUMBER',
  emergencyContactRelationship: 'PAX_RELATIONSHIP',
  name: 'PAX_NAME',
  passportExpiry: 'PAX_PASSPORT_EXPIRY',
  passportIssuer: 'PAX_PASSPORT_ISSUER',
  passportNationality: 'PAX_NATIONALITY',
  passportNumber: 'PAX_PASSPORT_NUM',
  passportResidence: 'PAX_COUNTRY_OF_RESIDENCE',

  // Timatic form
  timaticDocument: 'PAX_TIMATIC_DOCUMENT',
  timaticTravelType: 'PAX_TIMATIC_TRAVEL',
  timaticDate: 'PAX_TIMATIC_DATE',
  visaNumber: 'PAX_VISA_NUM',
  visaExpedition: 'PAX_VISA_ISSUER',
  visaExpiration: 'PAX_VISA_EXPIRY',
  visaDestination: 'PAX_VISA_DESTINATION',
  visaResidence: 'PAX_VISA_RESIDENCE',

  // Payment form
  addressApartment: 'REVIEW_APT_UNIT',
  addressCity: 'REVIEW_CITY',
  addressCountry: 'REVIEW_COUNTRY',
  addressStateUSCanada: 'REVIEW_STATE_PROVINCE',
  addressStateIntl: 'REVIEW_STATE_PROVINCE',
  addressStreet: 'REVIEW_STREET_ADDRESS',
  addressZip: 'REVIEW_ZIP_POSTAL',
  billingEmail: 'APP_EMAIL',
  billingPhone: 'REVIEW_PHONE_NUMBER',
  cardNumber: 'REVIEW_CARD_NUMBER',
  cardType: 'CARD_TYPE',
  cvc: 'REVIEW_CVC',
  expirationDate: 'REVIEW_EXPIRATION',
  expirationGiftCardDate: 'REVIEW_EXPIRATION',
  giftCardNumber: 'REVIEW_CARD_NUMBER',
  installmentPlanBankName: 'REVIEW_BANK_NAME',
  installmentPlanType: 'REVIEW_AVAILABLE_PAYMENT_PLANS',
  nameOnCard: 'REVIEW_NAME_ON_CARD',
  pin: 'PIN',
  privacyPolicy: 'APP_PRIVACY_POLICY',

  // Check-in forms
  reservationTicketNumber: 'CHECK_IN_RESERVATION_TICKET_NUMBER',

  // Contact us forms
  message: 'CONTACT_US_MESSAGE',

  // Contact Us Customer Service Form
  additionalComment: 'ADDITIONAL_COMMENT',
  customerServiceAddress: 'CONTACT_US_REVIEW_STREET_ADDRESS',
  customerServiceBoardingAirport: 'BOARDING_AIRPORT',
  customerServiceCity: 'CONTACT_US_REVIEW_CITY',
  customerServiceClubPremierAccountNumber: 'CLUB_PREMIERE_ACCOUNT_NUMBER',
  commentType: 'COMMENT_TYPE',
  country: 'CONTACT_US_PAX_COUNTRY',
  customerServiceEmailAddress: 'CONTACT_US_EMAIL',
  customerServiceRepeatEmail: 'CONTACT_US_REPEAT_EMAIL',
  customerServiceFlightDate: 'FLIGHT_DATE',
  customerServiceFlightNumber: 'CONTACT_US_FLIGHT_NUMBER',
  customerServiceLastName: 'CONTACT_US_PAX_LAST_NAME',
  customerServiceName: 'CONTACT_US_PAX_FIRST_NAME',
  customerServicePhoneNumber: 'CONTACT_US_PAX_PHONE_NUMBER',
  customerServiceState: 'CONTACT_US_REVIEW_STATE_PROVINCE',
  customerServiceZipCode: 'CONTACT_US_REVIEW_ZIP_POSTAL',
  clubPremierLevel: 'CONTACT_US_CLUB_PREMIERE_LEVEL',
  customerServiceCellPhone: 'CONTACT_US_CELL_PHONE',
  customerServicePhone: 'CONTACT_US_CUSTOMER_PHONE_NUMBER',
  customerServiceFareClass: 'CONTACT_US_FARE_CLASS',

  // Contact Us Investor Relations
  investorRelationsComment: 'CONTACT_US_INVESTOR_RELATIONS_COMMENT',
  investorRelationsCompany: 'CONTACT_US_COMPANY_NAME',
  investorRelationsEmailAddress: 'CONTACT_US_EMAIL',
  investorRelationsFullName: 'CONTACT_US_FULL_NAME',
  investorRelationsSubscribe: 'CONTACT_US_SUBSCRIBE_DISTRIBUTION',

  // Aeromexico vacations form
  aeromexicoVacationsEmail: 'CONTACT_US_EMAIL',
  aeromexicoVacationsFirstName: 'CONTACT_US_PAX_FIRST_NAME',
  aeromexicoVacationsLastName: 'CONTACT_US_PAX_LAST_NAME',
  aeromexicoVacationsPhoneNumber: 'CONTACT_US_PAX_PHONE_NUMBER',
  aeromexicoVacationsReservationCode: 'CONTACT_US_RESERVATION_CODE',

  // Aeromexico Investors suscribe form
  investorRelationsOffers: 'SUSCRIBE_INVESTORS_OFFERS',
  investorRelationsFormButton: 'SUSCRIBE_INVESTORS_BUTTON',
  investorDownloadFormButton: 'DOWNLOAD_INVESTORS_BUTTON',

  // Aeromexico vacations group form
  aeromexicoVacationsGroupDepartureDate: 'CONTACT_US_DEPARTURE_DATE',
  aeromexicoVacationsGroupDestination: 'APP_DESTINATION',
  aeromexicoVacationsGroupEmail: 'CONTACT_US_EMAIL',
  aeromexicoVacationsGroupFirstName: 'CONTACT_US_PAX_FIRST_NAME',
  aeromexicoVacationsGroupLastName: 'CONTACT_US_PAX_LAST_NAME',
  aeromexicoVacationsGroupNumberOfSeatsRequired: 'CONTACT_US_NUMBER_OF_SEATS_REQUIRED',
  aeromexicoVacationsGroupOrigin: 'APP_ORIGIN',
  aeromexicoVacationsGroupPhoneNumber: 'CONTACT_US_PAX_PHONE_NUMBER',
  aeromexicoVacationsGroupReturningDate: 'CONTACT_US_RETURNING_DATE',

  // User Profile login form
  userProfileClubPremierNumber: 'APP_CLUB_PREMIER_NUMBER',
  userProfileConfirmPassword: 'USER_PROFILE_CONFIRM_PASSWORD',
  userProfileDuplicateEmail: 'PRO_HOME2.0_ERROR_MAIL',
  userProfileInvalidEmailFormat: 'APP_VALIDATION_EMAIL_INVALID',
  userProfileEmail: 'APP_EMAIL',
  userProfileEmailNoMatchGuardian: 'PRO_HOME2.0_ERROR_ACCOUNT_TUTOR',
  userProfileFavoriteDepartureAiport: 'USER_PROFILE_PREFERRED_DEP_AIRPORT',
  userProfileFavoriteStoreFront: 'USER_PROFILE_PREFERRED_STORE',
  userProfileFirstName: 'PAX_FIRST_NAME',
  userProfileLastName: 'PAX_LAST_NAME',
  userProfileLoginInput: 'PRO_HOME2.0_LOGIN_FIELD',
  userProfileMiddleNameCP: 'PAX_MIDDLE_NAMES',
  userProfileMinorGuardian: 'PRO_HOME2.0_ERROR_AGE_TUTOR',
  userProfileNewPassword: 'USER_PROFILE_CREATE_PASSWORD',
  userProfileParents: 'USER_PROFILE_FFNUMBER_TUTOR',
  userProfilePassword: 'APP_PASSWORD',
  userProfilePrivacyPolicy: 'USER_PROFILE_SIGN_UP_DISCLAIMER_ADP',
  userProfileTelephonePinPlaceholder: 'PRO_HOME2.0_NIP_FIELD',
  userProfileTermsAndConditions: 'USER_PROFILE_SIGN_UP_DISCLAIMER_TYC',

  // User Inputs login form
  userProfileLoginPhone: 'PRO_HOME_LOGIN_PHONE',
  userProfileLoginPhoneError: 'PRO_HOME_LOGIN_SURNAME_ERROR',
  userProfileLoginDay: 'PRO_HOME_LOGIN_DAY',
  userProfileLoginDayError: 'PRO_HOME_LOGIN_DAY_ERROR',
  userProfileLoginMonth: 'PRO_HOME_LOGIN_MONTH',
  userProfileLoginMonthError: 'PRO_HOME_LOGIN_MONTH_ERROR',
  userProfileLoginYear: 'PRO_HOME_LOGIN_YEAR',
  userProfileLoginYearError: 'PRO_HOME_LOGIN_YEAR_ERROR',

  // User security login
  userProfileLoginSecurityTitle: 'PRO_HOME_LOGIN_ERROR_TITLE',
  userProfileLoginSecurityDesc: 'PRO_HOME_LOGIN_ERROR_DESCRIPTION',
  userProfileLoginSecurityButton: 'PRO_HOME_LOGIN_ERROR_BUTTON',
};

export default formFieldCopyIDs;
